// extracted by mini-css-extract-plugin
export default {"actions":"TableActions_actions__DKBfD"};